// extracted by mini-css-extract-plugin
module.exports = {"description":"ConnectEmailsPopup_description__3xBks","emailAddress":"ConnectEmailsPopup_emailAddress__12uIb"};